export default __webpack_public_path__ + "static/media/my nodes.152e2147.svg";